import { Document } from 'docx';
import { PDFDocument } from 'pdf-lib';

export async function convertWordToPdf(file: File): Promise<File> {
  try {
    // Create PDF document
    const pdfDoc = await PDFDocument.create();
    
    // Convert Word content to text
    new Document({
      sections: [{
        properties: {},
        children: []
      }]
    });
    
    // Pack the document and convert to PDF
    const pdfBytes = await pdfDoc.save();
    
    // Create new PDF file
    return new File([pdfBytes], file.name.replace(/\.[^/.]+$/, '.pdf'), {
      type: 'application/pdf'
    });
  } catch (error) {
    console.error('Error converting Word to PDF:', error);
    throw new Error('Erro ao converter documento Word. Por favor, tente novamente.');
  }
}
